<template>
  <v-menu
    v-bind="$attrs"
  >
    <template v-slot:activator="{ on, attrs }">
      <gg-btn
        id="filter-activator"
        v-bind="attrs"
        v-on="on"
      >
        <slot name="button-prepend"></slot>
        Filter
        <v-icon small class="ml-1">
          mdi-chevron-down
        </v-icon>
      </gg-btn>
    </template>
    <v-list
      class="py-2"
    >
      <template
        v-if="isNested"
      >
        <v-list-item
          v-for="(filterItem, index) in items"
          :key="index"
          style="display: block;"
        >
          <label class="d-block pt-3 pb-0 uppercase" style="font-size: 14px">
            {{ filterItem.label }}
          </label>
          <v-list-item-group
            multiple
            v-model="selectedItems"
            @change="changedSelection"
          >
            <v-list-item
              v-for="(item) in filterItem.items"
              :key="item.value"
              class="pa-0 mr-4"
              style="min-height: 24px;line-height: 20px"
              :value="item.value"
            >
              <template v-slot:default="{ active, }">
                <v-list-item-action class="mr-4 my-1 pl-0">
                  <v-checkbox
                    :input-value="active"
                    color="primary"
                  ></v-checkbox>
                </v-list-item-action>

                <v-list-item-content class="py-1" style="width: max-content">
                  <v-list-item-title>{{ item.label }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </v-list-item-group>
        </v-list-item>
      </template>
      <template
        v-else
      >
        <v-list-item>
          <v-list-item-group
            multiple
            v-model="selectedItems"
            @change="changedSelection"
          >
            <v-list-item
              v-for="(item) in items"
              :key="item.value"
              class="pa-0 mr-4"
              style="min-height: 24px;line-height: 20px"
              :value="item.value"
            >
              <template v-slot:default="{ active, }">
                <v-list-item-action class="mr-4 my-1 pl-0">
                  <v-checkbox
                    :input-value="active"
                    color="primary"
                  ></v-checkbox>
                </v-list-item-action>

                <v-list-item-content class="py-1" style="width: max-content">
                  <v-list-item-title>{{ item.label }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </v-list-item-group>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'GGFilter',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      selectedItems: [],
    }
  },
  computed: {
    isNested () {
      return this.items.at(0)?.items?.length > 0
    }
  },
  methods: {
    changedSelection (selectedFilters) {
      this.$emit('change', selectedFilters)
    }
  }
}
</script>
